import * as mutationTypes from '@/store/mutation-types.js'
import basicOperations from '@/mixins/basic-operations.js'
import stringOperations from '@/mixins/string-operations'
import mmItems from '@/mixins/main-menu-items.js'

export default {
  name: 'LandingPage',
  mixins: [basicOperations, stringOperations, mmItems],
  data() {
    return {
      mainMenuItemsForLandingPage: []
    }
  },

  created() { },

  mounted: function () {
    this.mainMenuItemsForLandingPage = this._mainMenuItemsForLandingPage()
    this.initMainSideMenu()
    this.initMenubarItems()
    this.initScreensRights()

    //true for begin login or false press home button
    // if(true && this.mainMenuItemsForLandingPage.length>1 ){
    //   this.redirect(this.mainMenuItemsForLandingPage[0])

    // }
  },

  computed: {
    nameOfUser() {
      return this._capitalizeFirstLetters(
        this.$store.state.userInfo.loggedInUserInformation.UserData.name
      )
    },
    nameOfSelectedLeerling() {
      return this.$store.state.oudersSpecific.selectedKid.Caption
    },
    isOuder() {
      return this.$store.state.userInfo.isOuder
    }
  },
  beforeCreate() {
    let veranderpaswoord = this.$store.state.userInfo.loggedInUserInformation.UserData.veranderpaswoord
    // eslint-disable-next-line
    if (Object.keys(WISA).length === 0 || veranderpaswoord || veranderpaswoord === undefined) {
      this.$router.push("/");
    }
  },
  methods: {
    setFlagvalues(screenName) {

      let menu = this.$store.state.userInfo.loggedInUserInformation.menu
      if (menu.Items.length > 0) {
        if (menu.Items.some(e => e.Form === screenName)) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
      // for (var x = 0; x < menu.Items.length; x++) {
      //   var hoofdmenuItem = menu.Items[x];
      //   if (hoofdmenuItem.Form === screenName) {
      //     return true
      //   }

      //   if (hoofdmenuItem.Items !== undefined) {
      //     for (var x2 = 0; x2 < hoofdmenuItem.Items.length; x2++) {
      //       var submenuItem = hoofdmenuItem.Items[x2];
      //       if (submenuItem.Form === screenName) {
      //         return true
      //       }
      //       if (submenuItem.Items !== undefined) {
      //         for (var x3 = 0; x3 < submenuItem.Items.length; x3++) {
      //           var subsubmenuItem = submenuItem.Items[x3];
      //           if (subsubmenuItem.Form === screenName) {
      //             return true
      //           }
      //         }
      //       }
      //     }
      //   }
      //   else{
      //     return false
      //   }
      // }      

    },
    initScreensRights() {
      this.$store.commit(mutationTypes.SET_SCREEN_RIGHTS,
        [
          this.setFlagvalues('MijnGegevens'),
          this.setFlagvalues('personaliaBewerken'),
          this.setFlagvalues('Agenda'),
          this.setFlagvalues('Aanwezigheden'),
          this.setFlagvalues('Opleiding'),
          this.setFlagvalues('Betalingen'),

        ])
    },
    redirect(redirection) {
      this.$store.commit(mutationTypes.SET_ACTIVE_MODULE, redirection.name)
      this.$store.commit(mutationTypes.MODULE_CHANGING_USING_MAIN_MENU, true)
      this._goTo(redirection.path)
    },
    initMenubarItems() {
      this.$store.commit(mutationTypes.SET_MENUBAR_ITEMS, {
        left: 'menu',
        title: 'Schoolware'
      })
    },
    initMainSideMenu() {
      this.$store.commit(
        mutationTypes.SET_MENU_ITEMS,
        this._mainMenuItemsForSideMenu()
      )
      if (/* this.$store.state.debugging && */ this.$store.state.mainMenuItems.length === 1) {
        this.$router.push(this.$store.state.mainMenuItems[0].path)
      }
      if (this.$store.state.flags.isLoginRedirected && this.mainMenuItemsForLandingPage.length > 1) {
        this.$router.push(this.$store.state.mainMenuItems[0].path)

      }
    }
  }
}
